module.exports = __webpack_public_path__ + "static/assets/56ed952f2b6983bccb7de9c507694bbb.svg";